import React from 'react';
import CardHeader from '../shared/CardHeader';
import cx from 'classnames';
import styles from './Rooster.css?module';
import {FlutterDMLRenderer} from './MWFlutterDMLRenderer';
import {formatQueryOverrides, populateFunctionOverrideExpressions} from '../../../state/card/cardService';
import {useRoosterCardTheme} from './useRoosterCardTheme';
import {useSelector} from 'react-redux';
import {selectIsFeatureEnabled} from '../../../state/feature/featureSelectors';

const getBackgroundColorHexFromTheme = theme => {
  const {colors, pages: [{background}]} = theme;
  const colorId = background.value;
  const color = colors.find(c => c.id === colorId);
  return color.value.value;
};

const RoosterContent = ({
                          contextEntityType,
                          contextEntityId,
                          filters,
                          dateRangeFilter,
                          functionOverrides,
                          card,
                          segments,
                          dateTimeElement,
                          overrideDateRange,
                          filterGroupIds,
                          dataControlFilters,
                          overriddenStyleId
                        }) => {

  const theme = useRoosterCardTheme(contextEntityType, contextEntityId);
  const backgroundColor = theme ? getBackgroundColorHexFromTheme(theme) : undefined;
  const chartPalette = theme ? theme.resolvedPalette : null;
  const { dml } = card.metadata;
  const dmlDefinition = JSON.parse(dml);
  const queryOverrides = formatQueryOverrides({
    filters,
    segments,
    dateRangeFilter,
    dateTimeElement,
    overrideDateRange,
    dataControlContext: { filterGroupIds, filters: dataControlFilters },
    functionOverrides: functionOverrides && populateFunctionOverrideExpressions(functionOverrides),
  });

  const debugDavinciNotebookEnabled = useSelector((state) => selectIsFeatureEnabled(
    state,
    'debug-davinci-notebook'
  ));

  return (
    <div className={styles.content} style={{background: backgroundColor}}>
      {debugDavinciNotebookEnabled && <div>
        {/*<h3>Debugging Information</h3>*/}
        {/*<div>Card ID: {card.id}</div>*/}
        <div>Context Entity Type: {contextEntityType}</div>
        <div>Context Entity ID: {contextEntityId}</div>
        <div>Overridden Style ID: {overriddenStyleId}</div>
        {/*<div>Filters: {JSON.stringify(filters)}</div>*/}
        {/*<div>Date Range Filter: {JSON.stringify(dateRangeFilter)}</div>*/}
        {/*<div>Function Overrides: {JSON.stringify(functionOverrides)}</div>*/}
        {/*<div>Segments: {JSON.stringify(segments)}</div>*/}
        {/*<div>Date Time Element: {JSON.stringify(dateTimeElement)}</div>*/}
        {/*<div>Override Date Range: {JSON.stringify(overrideDateRange)}</div>*/}
        {/*<div>Filter Group IDs: {JSON.stringify(filterGroupIds)}</div>*/}
        {/*<div>Data Control Filters: {JSON.stringify(dataControlFilters)}</div>*/}
      </div>}
      {theme && (
        <FlutterDMLRenderer
          dmlCardDefinition={dmlDefinition}
          isEditor={false}
          queryOverrides={queryOverrides}
          componentStyleId={overriddenStyleId}
          theme={theme}
          chartColorPaletteJson={chartPalette.palette}
          canvasBackgroundColor={backgroundColor}
        />
      )}
    </div>
  );
};

export const RoosterDetails = ({
                                 card,
                                 ...rest
                               }) => (
  <div>
    <RoosterContent
      card={card}
      {...rest}
    />
  </div>
);

export const RoosterCard = ({
                              card,
                              ...rest
                            }) => (
  <div className={cx(styles.text, styles.card)}>
    <CardHeader card={card} />
    <RoosterContent
      card={card}
      {...rest}
    />
  </div>
);
